export const createTabData = (tabData) => {
  return tabData.map((item) => {
    return {
      key: item.id,
      value: item.name,
      url: "/" + item.url,
    };
  });
};
